'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef, useContext } from 'react';
import { SuggestionContext } from './suggestion.js';
import '@digdir/designsystemet-web';

/**
 * Component that provides an empty Suggestion list.
 *
 * Place as a descendant of `Suggestion.List`
 *
 * @example
 * <Suggestion.List>
 *   <Suggestion.Empty>Tomt</Suggestion.Empty>
 * </Suggestion.List>
 */
const SuggestionEmpty = forwardRef(function SuggestionEmpty(rest, ref) {
    const { isEmpty } = useContext(SuggestionContext);
    return isEmpty ? (jsx("u-option", { "data-empty": true, ref: ref, suppressHydrationWarning // Since <u-option> adds attributes
        : true, value: '', ...rest })) : null;
});

export { SuggestionEmpty };
